import { SnackBarContext } from 'constants/contexts';
import React, { useState } from 'react';
import { Alert, Slide, Snackbar } from '@mui/material';
import useIsDesktop from 'hooks/useIsDesktop';
import { isApp } from 'utils/app';

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}
function SnackBarProvider({ children }) {
  const [data, setData] = useState({ });
  const isDesktop = useIsDesktop();
  const {
    message,
    type = 'info',
    autoHideDuration = 4000,
    anchorOrigin = isDesktop ? { vertical: 'bottom', horizontal: 'right' } : { vertical: 'top', horizontal: 'center' },
    showIcon = false,
  } = data;

  return (
    <SnackBarContext.Provider value={setData}>
      {children}
      <Snackbar
        open={Boolean(message)}
        autoHideDuration={autoHideDuration}
        anchorOrigin={anchorOrigin}
        onClose={() => setData({})}
        TransitionComponent={isApp() ? SlideTransition : undefined}
      >
        {
          message && (
            <Alert
              variant="filled"
              severity={type}
              sx={{ width: '100%', marginBottom: { xs: '70px', md: 'inherit' } }}
              {...(showIcon ? {} : { icon: false })}
            >
              {message}
            </Alert>
          )
        }

      </Snackbar>
    </SnackBarContext.Provider>
  );
}

export default SnackBarProvider;
